<div class="p-6 flex-table-page" data-testid="retail-store-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "retailStore.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="retail-store-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'retail-store-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onAdd()"
        (secondaryButtonClick)="onBatchDelete()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="retail-store-table"
      #advancedTable
      [dataSource]="retailStores()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [hasCheckColumn]="canDelete()"
      [selection]="selectedRetailStores()"
      scrollHeight="flex"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
    >
    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="retail-store-status-tag"
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="
            status
              ? ('common.table.status.active' | translate)
              : ('common.table.status.inactive' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Template for different column types -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column.prop === "selfPickupFlag") {
        <p-tag
          data-testid="retail-store-self-pickup-tag"
          [value]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          [severity]="value ? 'success' : 'danger'"
          styleClass="status-tag"
          [pTooltip]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      } @else if (column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column.prop === "typeCode") {
        <span class="text-xs text-gray-600">
          {{ "retailStore.types.general_shop" | translate }}
        </span>
      } @else {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center">
        @if (canUpdate()) {
          <app-button
            [testId]="'retail-store-action-edit'"
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [testId]="'retail-store-action-toggle-status'"
            [class]="rowData.status ? 'action-disable' : 'action-enable'"
            [label]="
              rowData.status
                ? ('common.table.actions.deactivate' | translate)
                : ('common.table.actions.activate' | translate)
            "
            type="action"
            (emitOnClick)="onStatusChange(rowData, !rowData.status)"
          ></app-button>
        }
        @if (canView()) {
          <app-button
            [testId]="'retail-store-action-view'"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
        @if (canDelete()) {
          <app-button
            [testId]="'retail-store-action-delete'"
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            [disabled]="rowData.status"
            [tooltip]="
              rowData.status
                ? ('retailStore.messages.cannot_delete_active' | translate)
                : ''
            "
            tooltipPosition="top"
            [showDelay]="300"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>

  <!-- Toast Messages -->
  <p-toast data-testid="retail-store-toast"></p-toast>

  <!-- Custom Confirmation Dialog -->
  <app-confirmation-dialog
    data-testid="retail-store-confirmation-dialog"
    [(visible)]="showConfirmationDialog"
    [title]="confirmationTitle()"
    [message]="confirmationMessage()"
    [buttons]="confirmationButtons()"
    (emitOnClick)="onConfirmationDialogAction($event)"
  ></app-confirmation-dialog>
</div>
